import { camelCase } from 'lodash'

export function Env (key = null) {
  if (key) {
    return import.meta.env[`VITE_APP_${key}`]
  }

  const get = (key) => {
    return import.meta.env[`VITE_APP_${key}`]
  }

  const isDev = () => {
    return import.meta.env.DEV === true
  }

  const assetUrl = (file) => {
    return new URL(file, import.meta.env.VITE_APP_ASSETS)
  }

  const mediaUrl = (file) => {
    return new URL(file, import.meta.env.VITE_APP_MEDIA_URL)
  }

  const keys = (keys) => {
    const params = {}
    for (const key of keys) {
      params[camelCase(key)] = get(key)
    }
    return params
  }

  return { isDev, assetUrl, mediaUrl, get, keys }
}
